export default __webpack_public_path__ + "static/taquito-5624be77c75d04b153ac45bdf31bfed0.png";